import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'archive',
    loadComponent: () =>
      import('./archive/archive.component').then((m) => m.ArchiveComponent),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'users',
    loadComponent: () =>
      import('./users/users.component').then((m) => m.UsersComponent),
    canActivate: [autoLoginPartialRoutesGuard],
  },
  {
    path: 'submissions/:submissionId',
    loadComponent: () =>
      import('./submission-detail/submission-detail.component').then(
        (m) => m.SubmissionDetailComponent,
      ),
    canActivate: [autoLoginPartialRoutesGuard],
  },
];
